/** @format */

import {CSSProperties} from 'react';

import {Typography} from '@mui/material';

import {useTheme} from '@mui/material/styles';

import {roundFloatNumber, divideBySpaces} from 'helpers/numberHelpers';

type Props = {
  number: number;
  colorize?: boolean;
  showPlusMinus?: boolean;
  isPositiveRed?: boolean;
  isGray?: boolean;
  postfix?: string;
  roundNumberBy?: number;
  style?: CSSProperties;
};

const WidgetFormattedNumber = ({
  number,
  isPositiveRed,
  isGray,
  showPlusMinus,
  postfix,
  colorize,
  roundNumberBy,
  style,
}: Props) => {
  const theme = useTheme();

  const roundedNumber = roundFloatNumber(number, roundNumberBy);
  const isPositive = roundedNumber >= 0;
  const isZero = roundedNumber === 0;
  let formattedNumber = divideBySpaces(roundedNumber);
  let color = theme.palette.figma_gray_light_4?.main;

  if (showPlusMinus && !isZero) {
    formattedNumber = isPositive ? `+${formattedNumber}` : formattedNumber;
  } else {
    formattedNumber = divideBySpaces(Math.abs(roundedNumber));
  }

  if (!isGray && colorize && !isZero) {
    color = (isPositiveRed ? !isPositive : isPositive) ? '#5AB983' : '#EC8786';
  }

  return (
    <Typography
      data-testid='widget-formatted-number'
      sx={{
        color,
        opacity: isGray ? 0.5 : 1,
        whiteSpace: 'nowrap',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '16px',
      }}
      style={style}
    >
      {formattedNumber || 0}
      {postfix ? postfix : null}
    </Typography>
  );
};

export default WidgetFormattedNumber;
